import React, { Component } from "react";
import ComponentHeader from "./ComponentHeader";
import classnames from "classnames";
import styles from "./Components.local.scss";
import { StandardBarChart } from "../../Common/Charts/StandardBarChart";
import ComponentActions from "./ComponentActions";
import { ICONS, SvgIcon } from "../../Common/Icons";
import { Modal, Tooltip } from "antd";
import _ from "i18n";

class BarChartComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFullView: false
    };
  }

  renderStandardBarChart = (data, ConfigComponentHeight, containerHeight) => {
    return (
      <StandardBarChart
        chartData={Object.values(data.data)}
        dataKeysY={data.accounts.map(({ code }) => code)}
        dataKeyX={"year"}
        currency={data.accounts[0].unit === "€"}
        legendLabels={data.accounts.map(({ label }) => label)}
        containerHeight={
          ConfigComponentHeight ? ConfigComponentHeight : containerHeight
        }
      />
    );
  };

  renderFullScreenIcon = () => {
    return (
      <Tooltip placement="top" title={_("fullScreen")}>
        <div
          className={styles.fullSreen_btn}
          onClick={() => this.setState({ isFullView: true })}
        >
          <SvgIcon icon={ICONS.FULL_SCREEN} />
        </div>
      </Tooltip>
    );
  };

  render() {
    const {
      slideId,
      isPreparePresentation,
      isComposition,
      isPresentation,
      hasComments,
      indicatorsExplanation,
      hasExplanation,
      component: {
        componentId,
        labels,
        data,
        config: {
          NoComponentHeader,
          ConfigComponentHeight,
          annexeAttachmentCategory
        }
      },
      layoutProps: { containerHeight }
    } = this.props;
    return (
      <div>
        {NoComponentHeader ? null : (
          <ComponentHeader
            slideId={slideId}
            percentage={false}
            title={labels}
            annexeAttachmentCategory={annexeAttachmentCategory}
            handleDisplayAnnexePDF={this.props.handleDisplayAnnexePDF}
            isComposition={isComposition}
            isPresentation={isPresentation}
            hasComments={hasComments}
            componentId={componentId}
            isPreparePresentation={isPreparePresentation}
            indicatorsExplanation={indicatorsExplanation}
            hasExplanation={hasExplanation}
            inSlideView={this.props.inSlideView}
          />
        )}

        <div
          className={classnames(
            styles.LineChartComponent,
            styles.flex_container
            // styles.align_container
          )}
        >
          {!this.props.inSlideView &&
            !this.props.isEmbedded && (
              <ComponentActions
                removeComponent={this.props.handleRemoveComponent}
                updateComponent={this.props.handleUpdateComponent}
                componentCase={this.props.ComponentCase}
                sideBar={"MultiIndicatorComponentConfig"}
                component={"BarChartComponent.png"}
              />
            )}
          {this.props.isEmbedded ? this.renderFullScreenIcon() : ""}
          <span
            className={classnames(
              "medium-12 small-12",
              styles.flex_container,
              styles.align_container
            )}
            style={containerHeight ? { alignItems: "baseLine" } : null}
          >
            {this.renderStandardBarChart(
              data,
              ConfigComponentHeight,
              containerHeight
            )}
          </span>
        </div>
        <Modal
          title={`Capitaux propres`}
          visible={this.state.isFullView}
          // visible={true}
          onOk={() => this.setState({ isFullView: false })}
          onCancel={() => this.setState({ isFullView: false })}
          width={1200}
          style={{ padding: "20px" }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              height: "450px",
              justifyContent: "center",
              alignItems: "center"
            }}
          >
            {this.renderStandardBarChart(
              data,
              ConfigComponentHeight,
              containerHeight
            )}
          </div>
        </Modal>
      </div>
    );
  }
}

export default BarChartComponent;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/BarChartComponent.js